import { getAsiAccessDecisionQueryKey, getComputerSubmitGateQueryKey, getCreditsBalanceQueryKey, getCreditsSettingsQueryKey, getCreditsTopupContextQueryKey, getQuotaQueryKey, getUbbConfigQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/billingKeys.js';
import { getHomepageUpsellsQueryKey, getNtpUpsellsQueryKey, getSidebarUpsellQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/upsellKeys.js';
import { getUserSettingsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/userKeys.js';
import { rateLimitStatusesQuery } from '#pplx/frontend/apps/ask/user-settings/rateLimitStatusesQuery.js';
import { getSearchModelsQueryKey } from '#pplx/frontend/ask-models/hooks/utilities/getSearchModelConfigQuery.js';
import { getPricingPlansQueryKey } from '#pplx/frontend/pricing-plans/pricingPlans.js';
/**
 * Invalidates all upsell-related React Query caches.
 * Call this after a subscription change (upgrade, new subscription, etc.)
 * to ensure users don't see stale upgrade prompts.
 */
const invalidateUpsellQueries = (queryClient) => {
    queryClient.invalidateQueries({ queryKey: getHomepageUpsellsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getNtpUpsellsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getSidebarUpsellQueryKey() });
};
/**
 * Invalidates all queries that depend on subscription status.
 * Call this after any subscription change (upgrade, downgrade, cancel, resume).
 * This includes upsells, user settings, and tier-dependent model configuration.
 */
export const invalidateSubscriptionQueries = (queryClient) => {
    // Drop the previous plan's quota while rechecking eligibility.
    void queryClient.resetQueries({ queryKey: getQuotaQueryKey() });
    invalidateUpsellQueries(queryClient);
    queryClient.invalidateQueries({ queryKey: getSearchModelsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getUserSettingsQueryKey() });
    queryClient.invalidateQueries({ queryKey: rateLimitStatusesQuery.getKey({}) });
    queryClient.invalidateQueries({ queryKey: getCreditsSettingsQueryKey() });
    queryClient.invalidateQueries({
        queryKey: getCreditsBalanceQueryKey({ includeCreditData: true }),
    });
    queryClient.invalidateQueries({ queryKey: getCreditsTopupContextQueryKey() });
    queryClient.invalidateQueries({ queryKey: getAsiAccessDecisionQueryKey() });
    queryClient.invalidateQueries({ queryKey: getComputerSubmitGateQueryKey() });
    // The catalog's consumer slice tracks the viewer's tier, so a tier change must
    // drop the cached row (the old client re-evaluated Eppo on session change).
    queryClient.invalidateQueries({ queryKey: getUbbConfigQueryKey() });
    queryClient.invalidateQueries({ queryKey: getPricingPlansQueryKey() });
};
//# sourceMappingURL=invalidateSubscriptionQueries.js.map